import React from 'react';

export function ProjectDocsHeader() {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 bg-white p-3 rounded-md border border-slate-100 ">
      <div className="flex flex-wrap items-center gap-3">
        {/* Tìm kiếm tài liệu */}
        <div className="relative min-w-[240px]">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />
          <input
            type="text"
            placeholder="Tìm kiếm tài liệu..."
            className="w-full h-9 pl-9 pr-4 rounded-md border border-slate-200 bg-slate-50 text-xs lg:text-sm focus:outline-none focus:border-emerald-500 focus:bg-white transition-all"
          />
        </div>

        {/* Các Select filters */}
        <FilterSelect placeholder="Tất cả loại tài liệu" />
        <FilterSelect placeholder="Tất cả thư mục" />
        <FilterSelect placeholder="Người tải lên" />

        <button className="h-9 px-4 rounded-md border border-slate-200 bg-white flex items-center gap-2 text-xs lg:text-sm font-normal text-slate-600 hover:bg-slate-50 transition-all">
          <i className="ri-filter-3-line" />
          <span>Bộ lọc</span>
        </button>
      </div>

      <button className="h-9 px-4 rounded-md bg-emerald-600 text-white flex items-center gap-2 text-xs lg:text-sm font-normal hover:bg-emerald-700 transition-all  shadow-emerald-100">
        <i className="ri-upload-2-line" />
        <span>Tải lên tài liệu</span>
      </button>
    </div>
  );
}

function FilterSelect({ placeholder }: { placeholder: string }) {
  return (
    <div className="relative group min-w-[140px]">
      <select className="appearance-none w-full h-9 pl-3 pr-8 rounded-md border border-slate-200 bg-slate-50 text-xs lg:text-sm text-slate-600 focus:outline-none focus:border-emerald-500 focus:bg-white transition-all cursor-pointer font-normal">
        <option value="">{placeholder}</option>
      </select>
      <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 group-hover:text-slate-600 pointer-events-none" />
    </div>
  );
}
